import subDays from 'date-fns/subDays';
import { formatDate } from 'helpers/date';

export interface IFilter {
  date: string[];
  id: number[];
  invoice_id: string[];
  customer_email: string;
}

export const initialValues: IFilter = {
  date: [formatDate(subDays(new Date(), 30), 'dd/MM/yyyy'), formatDate(new Date(), 'dd/MM/yyyy')],
  id: [],
  invoice_id: [],
  customer_email: ''
};
